export const guestMixin = {
  computed: {
    currentGuest() {
      return this.guest
    },
    orderCustomer() {
      return this.order.customer
    },
    roomChiefId() {
      return this.guests && this.guests[0] && this.guests[0].id
    },
    roomChiefTypologies() {
      return this.$store.getters['mappings/getGuestRoomChiefTypologies'](this.bookedGuestsCount || 0)
    },
    isRoomChief() {
      return !!this.currentGuest && !!this.currentGuest.typology && !!this.currentGuest.typology.includes('HEAD')
    },
    isSingle() {
      return !!this.currentGuest && !!this.currentGuest.typology && !!this.currentGuest.typology.includes('SINGLE')
    },
    isRoomChiefOrSingle() {
      return this.isRoomChief || this.isSingle
    },
    isGuestMale() {
      return this.currentGuest && this.currentGuest.sex === 'M'
    },
    guestGender() {
      return this.isGuestMale ? this.$t('guest.attributes.genders.male') : this.$t('guest.attributes.genders.female')
    },
    guestTypologyIcon() {
      if (this.isRoomChief) {
        return this.isGuestMale ? 'star-outline' : 'star-outline'
      } else {
        return this.isGuestMale ? 'face-outline' : 'face-woman-outline'
      }
    },
    insertedGuestsCount() {
      return this.reservation && this.reservation.guests.length
    },
    bookedGuestsCount() {
      return this.reservation && this.reservation.booked_guests
    },
    countryIds() {
      return {
        italy: 119,
        foreign: 999999,
      }
    },
  },
}
